var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    key: 'report-' + _vm.report.id,
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('m-header', {
    attrs: {
      "title": _vm.title,
      "chips": _vm.chips,
      "breadCrumbs": _vm.breadCrumbs,
      "alerts": _vm.alerts,
      "actions": _vm.actions,
      "c": " "
    },
    on: {
      "actionClicked": _vm.processAction,
      "alertClicked": _vm.processAction
    },
    scopedSlots: _vm._u([{
      key: "subtitle",
      fn: function fn() {
        return [_vm.report.customerName ? _c('v-tooltip', {
          attrs: {
            "bottom": "",
            "nudge-right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on;
              return [_c('small', _vm._g({
                staticClass: "mr-2",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-calendar-today-outline ")]), _vm._v(" " + _vm._s(_vm.report.timestamp.createdReadable) + " ")], 1)];
            }
          }], null, false, 504364785)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t("created")))])]) : _vm._e(), _vm.report.customerName ? _c('v-tooltip', {
          attrs: {
            "bottom": "",
            "nudge-right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on;
              return [_c('small', _vm._g({
                staticClass: "mr-2 cursor-pointer",
                attrs: {
                  "label": "",
                  "outlined": ""
                },
                on: {
                  "click": function click($event) {
                    _vm.isDriverDialogOpen = true;
                  }
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-steering ")]), _vm._v(" " + _vm._s(_vm.report.customerName) + " ")], 1)];
            }
          }], null, false, 2883502573)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t("enums.PersonType.DRIVER")))])]) : _vm._e(), _vm.report.numberplate ? _c('v-tooltip', {
          attrs: {
            "bottom": "",
            "nudge-right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on;
              return [_c('small', _vm._g({
                staticClass: "mr-2",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-car ")]), _vm._v(" " + _vm._s(_vm.report.numberplate) + " ")], 1)];
            }
          }], null, false, 3134839907)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.nouns.licenseplate")))])]) : _vm._e(), _vm.report.damageType ? _c('v-tooltip', {
          attrs: {
            "bottom": "",
            "nudge-right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on;
              return [_c('small', _vm._g({
                staticClass: "mr-2",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-car-brake-alert ")]), _vm._v(" " + _vm._s(_vm.$t("enums.DamageTypeEnum.".concat(_vm.report.damageType))) + " (" + _vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(_vm.report.coverageType))) + ") "), _vm.report.accidentDetails && _vm.report.accidentDetails.date ? _c('span', [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(new Date(_vm.report.accidentDetails.date))) + " ")]) : _vm._e()], 1)];
            }
          }], null, false, 134372389)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.report.damageType")))])]) : _vm._e(), _vm.report.status ? _c('v-tooltip', {
          attrs: {
            "bottom": "",
            "nudge-right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref5) {
              var on = _ref5.on;
              return [_c('small', _vm._g({
                staticClass: "mr-2",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-progress-helper ")]), _vm._v(" " + _vm._s(_vm.report.status) + " ")], 1)];
            }
          }], null, false, 3419570238)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.reportControl.status")))])]) : _vm._e(), _vm.createdBy ? _c('small', {
          staticClass: "mr-2",
          attrs: {
            "label": "",
            "outlined": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "grey"
          }
        }, [_vm._v(" mdi-note-edit-outline ")]), _vm._v(" " + _vm._s(_vm.$t("createdBy")) + " " + _vm._s(_vm.createdBy.firstName) + " " + _vm._s(_vm.createdBy.lastName) + " ")], 1) : _vm._e(), _c('div', {
          staticClass: "pt-1"
        }, _vm._l(_vm.chips, function (chip, index) {
          return _c('span', {
            key: 'chip' + index
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function fn(_ref6) {
                var on = _ref6.on;
                return [_c('v-chip', _vm._g({
                  staticClass: "mr-1 text-truncate",
                  attrs: {
                    "small": "",
                    "color": chip.color
                  },
                  on: {
                    "click": function click($event) {
                      return chip.exec();
                    }
                  }
                }, on), [chip.icon ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "left": ""
                  }
                }, [_vm._v(_vm._s(chip.icon))]) : _vm._e(), _vm._v(" " + _vm._s(chip.text) + " ")], 1)];
              }
            }], null, true)
          }, [_c('span', [_vm._v(" " + _vm._s(chip.tooltip))])])], 1);
        }), 0)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('partner-report-detail-change-progress', {
    attrs: {
      "isTimeLine": _vm.isTimeLine
    },
    model: {
      value: _vm.report,
      callback: function callback($$v) {
        _vm.report = $$v;
      },
      expression: "report"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-tabs', {
    attrs: {
      "flat": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.tabs, function (item) {
    return _c('v-tab', {
      key: item
    }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.tab.".concat(item))) + " ")]);
  }), 1)], 1)], 1), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-tabs-items', {
    class: _vm.isMobile ? '' : 'stretch',
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('partner-report-detail-damage')], 1), _vm.canRead(_vm.ResourceEnum.VEHICLE) ? _c('v-tab-item', [_c('partner-report-detail-vehicle')], 1) : _vm._e(), _vm.canReadRepair ? _c('v-tab-item', [_c('partner-report-detail-repair')], 1) : _vm._e(), _vm.canRead(_vm.ResourceEnum.RENTAL) ? _c('v-tab-item', [_c('partner-report-detail-rental')], 1) : _vm._e(), _vm.canRead(_vm.ResourceEnum.INVOICE) ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-invoice')], 1) : _vm._e(), _vm.canRead(_vm.ResourceEnum.DOCUMENT) ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-document', {
    attrs: {
      "report": _vm.report
    }
  })], 1) : _vm._e(), _vm.canRead(_vm.ResourceEnum.MESSAGE_INBOUND) ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-message', {
    attrs: {
      "report": _vm.report
    }
  })], 1) : _vm._e(), _vm.canReadContact ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-contact')], 1) : _vm._e(), _vm.canRead(_vm.ResourceEnum.TICKET) ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-ticket', {
    attrs: {
      "report": _vm.report
    }
  })], 1) : _vm._e(), _vm.canReadClaimSettlement ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-claim-settlement', {
    model: {
      value: _vm.report,
      callback: function callback($$v) {
        _vm.report = $$v;
      },
      expression: "report"
    }
  })], 1) : _vm._e(), _vm.can(_vm.ActionEnum.READ, _vm.ResourceEnum.REPORT_GROUP) ? _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('partner-report-detail-group', {
    model: {
      value: _vm.report,
      callback: function callback($$v) {
        _vm.report = $$v;
      },
      expression: "report"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.report.customerName,
      "subtitle": _vm.$t("enums.PersonType.DRIVER"),
      "icon": "mdi-steering",
      "isDialogActive": _vm.isDriverDialogOpen,
      "hideLeft": !_vm.isDriverDialogEdit,
      "hideRight": !_vm.isDriverDialogEdit,
      "leftLoading": _vm.isDriverLoading,
      "rightLoading": _vm.isDriverLoading,
      "loading": _vm.isDriverLoading,
      "persistent": _vm.isDriverDialogEdit,
      "rightText": _vm.$t('save')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDriverDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDriverDialogOpen = $event;
      },
      "close": _vm.closeDriverDialog,
      "leftClick": function leftClick($event) {
        return _vm.report.fetch();
      },
      "rightClick": _vm.saveCustomerInfo
    }
  }, [_c('template', {
    slot: "actions"
  }, [!_vm.isDriverDialogEdit ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "loading": _vm.isDriverLoading
    },
    on: {
      "click": function click($event) {
        _vm.isDriverDialogEdit = true;
      }
    }
  }) : _vm._e(), _vm.whatsappLink ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-whatsapp",
      "href": "#",
      "disabled": _vm.isDriverDialogEdit
    },
    on: {
      "click": _vm.openWhatsapp
    }
  }) : _vm._e(), _vm.report.customerContact && _vm.report.customerContact.phone ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-phone",
      "href": "tel:".concat(_vm.report.customerContact.phone),
      "disabled": _vm.isDriverDialogEdit
    }
  }) : _vm._e(), _vm.report.customerContact && _vm.report.customerContact.email ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-email-outline",
      "disabled": _vm.isDriverDialogEdit
    },
    on: {
      "click": _vm.openMail
    }
  }) : _vm._e()], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportDetail.driverInfo")) + ":")])])], 1), _vm.isDriverDialogEdit ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.firstName'),
      "readonly": !_vm.isDriverDialogEdit
    },
    model: {
      value: _vm.report.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "firstName", $$v);
      },
      expression: "report.firstName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.lastName'),
      "readonly": !_vm.isDriverDialogEdit
    },
    model: {
      value: _vm.report.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "lastName", $$v);
      },
      expression: "report.lastName"
    }
  })], 1)], 1) : _vm._e(), _vm.isDriverDialogEdit ? _c('v-divider', {
    staticClass: "py-2"
  }) : _vm._e(), _vm.report.customerContact ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.phone'),
      "readonly": !_vm.isDriverDialogEdit
    },
    model: {
      value: _vm.report.customerContact.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.report.customerContact, "phone", $$v);
      },
      expression: "report.customerContact.phone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.email'),
      "readonly": !_vm.isDriverDialogEdit
    },
    model: {
      value: _vm.report.customerContact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.report.customerContact, "email", $$v);
      },
      expression: "report.customerContact.email"
    }
  })], 1)], 1) : _vm._e(), _c('v-divider', {
    staticClass: "py-2"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.address'),
      "value": _vm.report.customerAddress,
      "readonly": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.company'),
      "readonly": !_vm.isDriverDialogEdit
    },
    model: {
      value: _vm.report.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "companyName", $$v);
      },
      expression: "report.companyName"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "py-2"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('language'),
      "value": _vm.$t("enums.LanguageCodeEnum.".concat(_vm.report.language)) + ' ' + _vm.getFlagEmojiByLanguage(_vm.report.language)
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('report.formPersonalData.whatsAppContactOptin'),
      "items": [true, false],
      "append-icon": _vm.readonly ? '' : undefined
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.report.whatsAppContactOptIn,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "whatsAppContactOptIn", $$v);
      },
      expression: "report.whatsAppContactOptIn"
    }
  })], 1)], 1)], 2), _c('template-dialog', {
    key: 'template' + _vm.report.id,
    ref: "templateDialog",
    attrs: {
      "hideButton": true,
      "fullscreen": false,
      "partnerId": _vm.partner._id,
      "context": _vm.templateDialogMethods.context,
      "to": _vm.templateDialogMethods.to,
      "from": _vm.templateDialogMethods.from,
      "refs": [{
        refId: _vm.report.id,
        refType: _vm.ResourceEnum.REPORT
      }],
      "isTicketEnabled": true
    }
  }), _c('report-activity-share-dialog', {
    key: 'share' + _vm.report.id,
    ref: "shareDialog",
    attrs: {
      "fullscreen": false
    }
  }), _c('partner-report-detail-delete-dialog', {
    key: 'delete' + _vm.report.id,
    ref: "deleteDialog",
    attrs: {
      "hideButton": true
    }
  }), _vm.isActivityOpen ? _c('side-card', {
    attrs: {
      "title": _vm.$t('timeLine.ThgQuoteDetailCardActivityTimeLineSideCard.title'),
      "width": "800px"
    },
    on: {
      "close": function close($event) {
        _vm.isActivityOpen = false;
      }
    }
  }, [_c('v-timeline', {
    staticClass: " py-2",
    attrs: {
      "dense": "",
      "clipped": ""
    }
  }, [_vm.activityLog && _vm.activityLog.length ? _c('activity-time-line') : _vm._e()], 1), _c('v-card', {
    attrs: {
      "outlined": "",
      "flat": ""
    }
  }, [_c('v-divider'), _c('report-activity-box-comment-component', {
    attrs: {
      "isEditorMobile": true,
      "partnerId": _vm.partner.id,
      "report": _vm.report
    }
  })], 1)], 1) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('components.partner.PartnerReportDetail.summarize'),
      "hideRight": true,
      "hideLeft": true,
      "persistent": true,
      "isDialogActive": _vm.isSummaryDialogActive
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isSummaryDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isSummaryDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isSummaryDialogActive = false;
      }
    }
  }, [_vm.summaryLoading ? _c('v-row', [_c('v-col', [_c('a-ei-loading', {
    attrs: {
      "width": 500
    }
  })], 1)], 1) : _vm._e(), _vm.summary ? _c('v-else', {
    domProps: {
      "innerHTML": _vm._s(_vm.summary)
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }